<h1 class="page-title">Impressum</h1>
<div class="impressum-container">
  <app-card title="Content and Administrative Responsibility">
    <strong>Manuel Fischer</strong><br />
    Bern University of Applied Sciences – Department of Business<br />
    Sustainable Development<br />
    Falkenstrasse 16<br />
    3005 Bern, Switzerland<br />
    <br />
    <span
      ><a href="mailto:sustainability@bfh.ch"
        >sustainability&#64;bfh.ch</a
      ></span
    >
  </app-card>

  <app-card title="Design and Technical Implementation">
    <strong>Digital Sustainability Lab</strong><br />
    Bern University of Applied Sciences – Department of Business<br />
    Brückenstrasse 73<br />
    3005 Bern, Switzerland<br />
    <br />
    <span><a href="mailto:dsl@bfh.ch">dsl&#64;bfh.ch</a></span
    ><br />
    <a
      href="https://www.bfh.ch/de/forschung/forschungsbereiche/digital-sustainability-lab/"
      target="_blank"
      >Digital Sustainability Lab</a
    >
  </app-card>
</div>
